import { Navigate, Route, Routes } from "react-router-dom";

import AuthGate from "@/components/AuthGate";
import AppShell from "@/components/layout/AppShell";
import PartnerList from "@/features/partners/PartnerList";
import ProcessList from "@/features/processes/ProcessList";
import ProjectDetail from "@/features/projects/ProjectDetail";
import ProjectList from "@/features/projects/ProjectList";
import QuotationDetail from "@/features/quotations/QuotationDetail";
import QuotationItemDetail from "@/features/quotations/QuotationItemDetail";
import QuotationList from "@/features/quotations/QuotationList";
import ShippingCalendar from "@/features/shipping-calendar/ShippingCalendar";
import UserList from "@/features/users/UserList";
import WorkLogEntry from "@/features/work-logs/WorkLogEntry";
import HomePage from "@/routes/home";
import LoginPage from "@/routes/login";
import PasswordChangePage from "@/routes/password-change";

export default function App() {
  return (
    <Routes>
      <Route path="/login" element={<LoginPage />} />
      {/* パスワード変更は AppShell の外に置く。仮パスワードのまま他の画面へ
          行かせないため、ここだけは AuthGate の強制リダイレクトの対象外。 */}
      <Route
        path="/password-change"
        element={
          <AuthGate>
            <PasswordChangePage />
          </AuthGate>
        }
      />
      {/* 図面 QR の着地点。現場のスマホで開くので AppShell（ヘッダ・ドロワー・
          横長テーブル前提の枠）は被せず、AuthGate だけを通す。 */}
      <Route
        path="/q"
        element={
          <AuthGate>
            <WorkLogEntry />
          </AuthGate>
        }
      />
      {/* 認証が必要な画面はまとめて AuthGate の内側に置く。 */}
      <Route
        element={
          <AuthGate>
            <AppShell />
          </AuthGate>
        }
      >
        <Route path="/" element={<HomePage />} />
        <Route path="/quotations" element={<QuotationList />} />
        <Route path="/quotations/:quotationId" element={<QuotationDetail />} />
        <Route
          path="/quotations/:quotationId/items/:quotationItemId"
          element={<QuotationItemDetail />}
        />
        <Route path="/projects" element={<ProjectList />} />
        <Route path="/projects/:projectId" element={<ProjectDetail />} />
        <Route path="/shipping-calendar" element={<ShippingCalendar />} />
        <Route path="/master/partners" element={<PartnerList />} />
        <Route path="/master/processes" element={<ProcessList />} />
        <Route path="/master/users" element={<UserList />} />
      </Route>
      {/* 未定義パスはトップへ。 */}
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}
